import {
  getDesktopControlPanelItems,
  getDesktopDashboardZones,
  getDesktopNonDashboardItems,
  toLegacyNavItems,
} from '@/lib/navigation/nav-presenters';
import type { LegacyNavItem, NavVisibilityContext } from '@/lib/navigation/types/nav-types';
import type { DashboardNavZones } from '../types/sidebar-nav-types';

export function getDashboardNavZones(hasShopifyData: boolean): DashboardNavZones {
  const zones = getDesktopDashboardZones({
    hasShopifyData,
    accountFeatureFlagNames: [],
  });
  return {
    primaryPins: toLegacyNavItems(zones.primaryPins),
    reports: toLegacyNavItems(zones.reports),
  };
}

export function getSetupItems(
  context: NavVisibilityContext = { hasShopifyData: true, accountFeatureFlagNames: [] }
): LegacyNavItem[] {
  return toLegacyNavItems(getDesktopControlPanelItems(context));
}

export const SETUP_ITEMS: LegacyNavItem[] = getSetupItems();

export function getNonDashboardItems(context: NavVisibilityContext): LegacyNavItem[] {
  return toLegacyNavItems(getDesktopNonDashboardItems(context));
}

